<template>
  <ms-popup
    v-if="activePopup"
    class="popup-notification"
    :title="titlePopup"
    :active="activePopup"
    :borderFooter="false"
    @close="handleClosePopup"
    @keyEscape="closePopup"
    @keyEnter="handlePopup"
    width="415"
  >
    <template v-slot:content>
      <ms-input autofocus class="input-hidden" :globalPopup="true" />
      <div v-if="typePopup == 1">
        <span v-html="contentPopup"></span>
      </div>
      <div v-if="typePopup == 2">
        <span v-html="contentPopup"></span>
      </div>
      <div v-if="typePopup == 3">
        <span v-if="!isCustomtext">{{firstText}}</span>
        <span v-html="contentPopup"></span>
        <span v-if="!isCustomtext">{{lastText}}</span>
      </div>
      <div v-if="typePopup == 4">
        <span v-html="contentPopup"></span>
      </div>
      <div v-if="typePopup == 5">
        <span v-html="contentPopup"></span>
      </div>
    </template>
    <template v-slot:footer>
      <div v-if="typePopup == 1">
        <MsButton
          color="primary"
          type="filled"
          minWidth="80"
          @click="handleClosePopup"
        >{{textBtnClose}}</MsButton>
      </div>
      <div v-if="typePopup == 2" class="flex">
        <MsButton
          class="m-r-8"
          color="secondary"
          type="filled"
          minWidth="80"
          @click="handleClosePopup"
        >{{textBtnClose}}</MsButton>
        <MsButton color="primary" type="filled" minWidth="80" @click="handleConfirm" :loading="saveLoading">
          {{textBtnConfirm}}
        </MsButton>
      </div>
      <div v-if="typePopup == 3">
        <MsButton
          class=""
          color="secondary"
          type="filled"
          minWidth="80"
          @click="handleClosePopup"
        >{{textBtnClose}}</MsButton>
        <MsButton color="danger" type="filled" minWidth="80" @click="handleDelete" :loading="saveLoading">
          {{textBtnDelete}}
        </MsButton>
      </div>
      <div v-if="typePopup == 4">
        <MsButton
          class="m-r-8"
          color="secondary"
          type="filled"
          minWidth="80"
          @click="closePopup"
        >{{textBtnClose}}</MsButton>
        <MsButton
          class="m-r-8"
          color="secondary"
          type="filled"
          minWidth="80"
          @click="handleClosePopup"
        >{{textBtnNoSave}}</MsButton>
        <MsButton color="primary" type="filled" minWidth="80" @click="handleConfirm" :loading="saveLoading">
          {{textBtnSave}}
        </MsButton>
      </div>
      <div v-if="typePopup == 5">
        <MsButton
          class="m-r-8"
          color="secondary"
          type="filled"
          minWidth="80"
          @click="handleClosePopup"
        >{{textBtnClose}}</MsButton>
        <MsButton color="primary" type="filled" minWidth="80" @click="handleConfirm" :loading="saveLoading">
          {{textBtnUpdate}}
        </MsButton>
      </div>
    </template>
  </ms-popup>
</template>
<script>
import MsButton from "../ms-button/MsButton.vue";
import i18n from "@/i18ns/i18n.js";
export default {
  name: "MsPopupNotification",
  components: {
    MsButton
  },
  data() {
    return {
      titlePopup: "",
      contentPopup: "",
      activePopup: false,
      typePopup: 2, //Dạng popup thông báo: 1: Thông báo, 2: Xóa, 3: Thông báo 2 button xanh trắng, 4: Nhắc nhở đóng form thêm sửa
      callBackClosePopup: null,
      callBackDelete: null,
      textBtnClose: "",
      textBtnDelete: "",
      textBtnConfirm: "",
      textBtnSave: "",
      textBtnNoSave: "",
      textBtnUpdate: "",
      firstText: i18n.tc("i18nCommon.FirstTextDelete"),
      lastText: i18n.tc("i18nCommon.LastTextDelete"),
      dataDelete: null,
      dataClosePopup: null,
      saveLoading: false,
      callBackConfirm: null,
      dataConfirm: null,
      isClose: true,
      isCustomtext: false
    };
  },
  methods: {
    /**
     * Hàm đóng thông báo
     * created by CVCUONG1 10/12/2020
     */
    closePopup() {
      if (this.isClose) {
        this.activePopup = false;
      } else {
        this.isClose = true;
      }
    },
    /**
     * Hàm sét khồng đóng thông báo
     * created by CVCUONG1 10/12/2020
     */
    setClosePopup() {
      this.isClose = false;
    },
    /**
     * Hàm bắt sự kiện enter form
     * created by CVCUONG1 5/1/2020
     */
    async handlePopup() {
      if (this.typePopup == 1 || this.typePopup == 2 || this.typePopup == 4) {
        await this.handleConfirm();
      } else if (this.typePopup == 3) {
        await this.handleDelete();
      }
    },
    /**
     * Hàm thực hiện click button đóng hay hủy
     * created by CVCUONG1 10/12/2020
     */
    handleClosePopup() {
      if (this.callBackClosePopup != null) {
        if (this.dataClosePopup == null) {
          this.callBackClosePopup();
        } else {
          this.callBackClosePopup(this.dataClosePopup);
        }
      }
      this.closePopup();
    },
    /**
     * Hàm thực hiện click button đồng ý
     * created by CVCUONG1 10/12/2020
     */
    async handleConfirm() {
      this.saveLoading = true;
      if (this.callBackConfirm != null) {
        if (this.dataConfirm == null) {
          await this.callBackConfirm();
          this.saveLoading = false;
          this.closePopup();
        } else {
          await this.callBackConfirm(this.dataConfirm);
          this.saveLoading = false;
          this.closePopup();
        }
      } else {
        this.saveLoading = false;
        this.closePopup();
      }
    },
    /**
     * Hàm thực hiện khi click button xóa
     * created by CVCUONG1 10/12/2020
     */
    async handleDelete() {
      this.saveLoading = true;
      if (this.callBackDelete != null) {
        if (this.dataDelete == null) {
          await this.callBackDelete();
          this.saveLoading = false;
          this.closePopup();
        } else {
          await this.callBackDelete(this.dataDelete);
          this.saveLoading = false;
          this.closePopup();
        }
      } else {
        this.saveLoading = false;
        this.closePopup();
      }
    },
    /**
     * Hàm bật popup
     * created by CVCUONG1 10/12/2020
     */
    open() {
      this.activePopup = true;
    },
    /**
     * Hàm thực hiện bật popup confirm xóa
     * created by CVCUONG1 10/12/2020
     * @param title title của popup
     * @param content nội dung popup
     * @param callBackDelete hàm thực hiện khi bấm nút xóa
     * @param callBackClosePopup hàm thực hiện khi bấm nút hủy
     */
    confirmDelete(
      title = i18n.tc("i18nCommon.Warning"),
      content,
      callBackDelete = null,
      dataDelete = null,
      callBackClosePopup = null,
      dataClosePopup = null,
      textBtnClose = i18n.tc("i18nCommon.Cancel"),
      textBtnDelete = i18n.tc("i18nCommon.Delete"),
      isCustomtext = false
    ) {
      this.typePopup = 3;
      if (title == null || title == "") {
        this.titlePopup = i18n.tc("i18nCommon.Notify");
      } else {
        this.titlePopup = title;
      }
      this.contentPopup = content;
      this.callBackClosePopup = callBackClosePopup;
      this.callBackDelete = callBackDelete;
      this.textBtnClose = textBtnClose;
      this.textBtnDelete = textBtnDelete;
      this.dataDelete = dataDelete;
      this.dataClosePopup = dataClosePopup;
      this.isCustomtext = isCustomtext;
      this.open();
    },
    /**
     * Hàm thực hiện bật popup dạng thông báo
     * created by CVCUONG1 10/12/2020
     * @param title title của popup
     * @param content nội dung popup
     * @param callBackClosePopup hàm thực hiện khi bấm nút Đóng
     */
    showNotify(
      title = i18n.tc("i18nCommon.Notify"),
      content,
      callBackClosePopup = null,
      dataClosePopup = null,
      textBtnClose = i18n.tc("i18nCommon.Close")
    ) {
      this.typePopup = 1;
      if (title == null || title == "") {
        this.titlePopup = i18n.tc("i18nCommon.Notify");
      } else {
        this.titlePopup = title;
      }
      this.contentPopup = content;
      this.callBackClosePopup = callBackClosePopup;
      this.textBtnClose = textBtnClose;
      this.dataClosePopup = dataClosePopup;
      this.open();
    },
    /**
     * Hàm thực hiện bật popup dạng thông báo
     * created by CVCUONG1 10/12/2020
     * @param title title của popup
     * @param content nội dung popup
     * @param callBackClosePopup hàm thực hiện khi bấm nút Đóng
     */
    showConfirm(
      title = i18n.tc("i18nCommon.Notify"),
      content,
      callBackConfirm = null,
      dataConfirm = null,
      callBackClosePopup = null,
      dataClosePopup = null,
      textBtnConfirm = i18n.tc("i18nCommon.Agree"),
      textBtnClose = i18n.tc("i18nCommon.Cancel2")
    ) {
      this.typePopup = 2;
      if (title == null || title == "") {
        this.titlePopup = i18n.tc("i18nCommon.Notify");
      } else {
        this.titlePopup = title;
      }
      this.contentPopup = content;
      this.callBackConfirm = callBackConfirm;
      this.dataConfirm = dataConfirm;
      this.callBackClosePopup = callBackClosePopup;
      this.dataClosePopup = dataClosePopup;
      this.textBtnClose = textBtnClose;
      this.textBtnConfirm = textBtnConfirm;
      this.open();
    },
    /**
     * Hàm thực hiện bật popup dạng thông báo
     * created by CVCUONG1 10/12/2020
     * @param title title của popup
     * @param content nội dung popup
     * @param callBackClosePopup hàm thực hiện khi bấm nút Đóng
     */
    confirmCloseForm(
      title = i18n.tc("i18nCommon.Notify"),
      content = i18n.tc("i18nCommon.ConfimSave"),
      callBackSave = null,
      dataSave = null,
      callBackNoSave = null,
      dataNoSave = null,
      textBtnSave = i18n.tc("i18nCommon.Save"),
      textBtnNoSave = i18n.tc("i18nCommon.NoSave"),
      textBtnClose = i18n.tc("i18nCommon.Cancel")
    ) {
      this.typePopup = 4;
      if (title == null || title == "") {
        this.titlePopup = i18n.tc("i18nCommon.Notify");
      } else {
        this.titlePopup = title;
      }
      if (content == null || content == "") {
        this.contentPopup = i18n.tc("i18nCommon.ContentConfirm");
      } else {
        this.contentPopup = content;
      }
      this.callBackConfirm = callBackSave;
      this.dataConfirm = dataSave;
      this.callBackClosePopup = callBackNoSave;
      this.dataClosePopup = dataNoSave;
      this.textBtnSave = textBtnSave;
      this.textBtnNoSave = textBtnNoSave;
      this.textBtnClose = textBtnClose;
      this.open();
    },
    /**
     * Hàm cảnh bóng đóng form khi có thay đổi
     * Created by CVCUONG1 - 26/2/2021
     * @param objOld Data cũ
     * @param objNew Data mới
     */
    confirmSave(
      objOld,
      objNew,
      callBackSave = null,
      dataSave = null,
      callBackNoSave = null,
      dataNoSave = null,
      textBtnSave = i18n.tc("i18nCommon.Save"),
      textBtnNoSave = i18n.tc("i18nCommon.NoSave"),
      textBtnClose = i18n.tc("i18nCommon.Cancel")){
        this.typePopup = 4;
        this.titlePopup = i18n.tc("i18nCommon.Notify");
        this.contentPopup = i18n.tc("i18nCommon.ContentConfirm");
        if(JSON.stringify(objOld) == JSON.stringify(objNew)){
          callBackNoSave();
          return;
        }
        this.callBackConfirm = callBackSave;
        this.dataConfirm = dataSave;
        this.callBackClosePopup = callBackNoSave;
        this.dataClosePopup = dataNoSave;
        this.textBtnSave = textBtnSave;
        this.textBtnNoSave = textBtnNoSave;
        this.textBtnClose = textBtnClose;
        this.open();
      },
    /**
     * Hàm thực hiện bật popup confirm cập nhật ca
     * created by THDUONG 29/12/2020
     * @param title title của popup
     * @param content nội dung popup
     * @param callBackDelete hàm thực hiện khi bấm nút xóa
     * @param callBackClosePopup hàm thực hiện khi bấm nút hủy
     */
    confirmUpdate(
      title = i18n.tc("i18nCommon.Warning"),
      content,
      callBackConfirm = null,
      callBackClosePopup = null,
      textBtnClose = i18n.tc("i18nCommon.Cancel2"),
      textBtnUpdate = i18n.tc("i18nCommon.Update")
    ) {
      this.typePopup = 5;
      if (title == null || title == "") {
        this.titlePopup = i18n.tc("i18nCommon.Notify");
      } else {
        this.titlePopup = title;
      }
      this.contentPopup = content;
      this.callBackClosePopup = callBackClosePopup;
      this.callBackConfirm = callBackConfirm;
      this.textBtnClose = textBtnClose;
      this.textBtnUpdate = textBtnUpdate;
      this.open();
    }
  }
};
</script>
<style lang="scss" scoped>
.popup-notification {
  z-index: 999999999999999 !important;
}
.input-hidden {
  opacity: 0;
  position: absolute;
  z-index: -1;
}
</style>
